import React, { FC, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { BottomSheet, Button, Icon } from "../../components/common";
import { InvoiceDropdown } from "../../components/menu";
import { EditInvoiceNumberFormModal } from "../../components/modals/EditInvoiceNumberModal";
import { STATUS_CONFIG } from "../../constants";
import { useDisplayInvoiceWalletSection } from "../../hooks/useDisplayInvoiceWalletSection";
import { ROUTES } from "../../routes";
import {
  selectInvoice,
  selectStep,
  previousState,
  MAX_STEPS,
} from "../../store/reducers/invoice";
import { StatusSet } from "../../types/GlobalTypes";
import { InvoiceStatus } from "../../types/InvoiceTypes";

const STATUS_PROPS = STATUS_CONFIG[StatusSet.INVOICE];

type Props = {};

export const Header: FC<Props> = () => {
  const invoice = useSelector(selectInvoice);
  const step = useSelector(selectStep);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openEditNumber, setOpenEditNumber] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const showWalletForm = useDisplayInvoiceWalletSection(invoice);

  if (!invoice) {
    return <></>;
  }

  const { number, status, user_is_payer } = invoice;

  const statusProps = STATUS_PROPS[status];

  const onClickBack = () => {
    if (status !== InvoiceStatus.DRAFT || step === 1) {
      navigate(user_is_payer ? ROUTES.PAY : ROUTES.RECEIVE);
    } else {
      const skipPrev = step === 4 && !showWalletForm;
      dispatch(previousState(skipPrev));
    }
  };

  const onDelete = () => {
    navigate(user_is_payer ? ROUTES.PAY : ROUTES.RECEIVE);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 p-4 flex flex-col gap-1 font-manrope bg-purple-50 !z-[25]">
        <div className="flex justify-between">
          <div className="flex">
            <Button
              className="p-0"
              icon
              onClick={onClickBack}
              variant={Button.variant.TERTIARY}
            >
              <Icon
                icon={status === InvoiceStatus.DRAFT ? "Arrow-left" : "Close"}
                size={24}
                className="white"
              />
            </Button>

            <h1 className="flex justify-center items-center font-semibold text-base	text-gray-500">
              Invoice #{number}
              <span>&nbsp;·&nbsp;</span>
              <span className={statusProps.color}>{statusProps.text}</span>
            </h1>
          </div>

          <div>
            {status === InvoiceStatus.DRAFT && step < 3 && (
              <Button
                icon
                onClick={() => setOpenEditNumber(true)}
                variant={Button.variant.TERTIARY}
              >
                <Icon icon="Edit" size={18} disableFill />
              </Button>
            )}

            <Button
              icon
              onClick={() => setOpenMenu(true)}
              variant={Button.variant.TERTIARY}
            >
              <Icon icon="Dot-Menu" size={24} disableFill />
            </Button>
          </div>
        </div>

        {status === InvoiceStatus.DRAFT && (
          <div className="ml-12 text-sm theme-text-secondary">
            Step {step} of {MAX_STEPS}
          </div>
        )}
      </header>

      {openEditNumber && (
        <EditInvoiceNumberFormModal
          isOpen={openEditNumber}
          close={() => setOpenEditNumber(false)}
        />
      )}

      <BottomSheet isOpen={openMenu} close={() => setOpenMenu(false)}>
        {openMenu && (
          <InvoiceDropdown
            data={invoice}
            closeDropdown={() => setOpenMenu(false)}
            popover={false}
            onDelete={onDelete}
          />
        )}
      </BottomSheet>
    </>
  );
};
